module.exports = __webpack_public_path__ + "img/gallery-nft-12.b0eca52c.png";